import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppLayout from './AppLayout';
import ElanController from './api/elan/ElanController'; // ElanController düzgün yoldan import et
import moment from 'moment';

function App() {

  useEffect(() => {
    const checkAndUnboostExpiredElans = async () => {
      try {
        const allElans = await ElanController.getAllElans();
        const today = moment().startOf('day'); // Bu günün başlanğıcı

        const expiredElans = allElans.filter(elan => {
          if (elan.premium && elan.expireDate) {
            const expireDate = moment(elan.expireDate);
            return expireDate.isSameOrBefore(today, 'day');
          }
          return false;
        });

        for (const elan of expiredElans) {
          await ElanController.updateElan(elan.id, {
            premium: false,
            expireDate: null,
          });
        }
      } catch (error) {
        console.error('Elanların expire tarixi yoxlanarkən xəta:', error);
      }
      
    };
    
    checkAndUnboostExpiredElans();
  }, []);

  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;

